import { Routes } from '@angular/router';


import { HomeComponent } from '../../back-office/home/home.component';
import { FamilyMembersComponent } from '../../back-office/family-members/family-members.component';
import { personalInformation } from '../../back-office/personal-information/personal-information.component';
import { ProfileComponent } from '../../back-office/profile/profile.component';
import { PackageComponent } from '../../back-office/package/package.component';
import { ContactUsComponent } from '../../back-office/contact-us/contact-us.component';
import { PackageDetailsComponent } from '../../back-office/package-details/package-details.component';
import { FaqsComponent } from '../../back-office/faqs/faqs.component';
import { BookingReviewComponent } from '../../back-office/booking-review/booking-review.component';
import { BookingsComponent } from '../../back-office/bookings/bookings.component';
import { SavedItineraryComponent } from '../../back-office/saved-itinerary/saved-itinerary.component';
import { MedicationsComponent } from '../../back-office/medications/medications.component';
import { GovernmentTravelAdvice } from '../../back-office/government-travel-advice/government-travel-advice.component';
import { PrivacyStatement } from '../../back-office/privacy-statement/privacy-statement.component';
import { RulesAndRestrictionComponent } from '../../back-office/rules-and-restriction/rules-and-restriction.component';
import { TermsOfUseComponent } from '../../back-office/terms-of-use/terms-of-use.component';
import { KumbhComponent } from '../../back-office/kumbh/kumbh.component';
import { DivineDestinationComponent } from '../../back-office/divine-destination/divine-destination.component';
import { TrendingFestivalComponent } from '../../back-office/trending-festival/trending-festival.component';
import { WhoAreWeComponent } from '../../back-office/who-are-we/who-are-we.component';
import { AboutUsComponent } from '../../back-office/about-us/about-us.component';
import { WhyChooseUsComponent } from '../../back-office/why-choose-us/why-choose-us.component';
import { CancellationPolicyComponent } from '../../back-office/cancellation-policy/cancellation-policy.component';
import { HappyTravelerComponent } from '../../back-office/happy-traveler/happy-traveler.component';
import { AiTripComponent } from '../../back-office/admin/ai-trip-planner/ai-trip/ai-trip.component';
import { AiTripFirstComponent } from '../../back-office/admin/ai-trip-planner/ai-trip-first/ai-trip-first.component';
import { AiTripSecondComponent } from '../../back-office/admin/ai-trip-planner/ai-trip-second/ai-trip-second.component';
import { AiItineraryComponent } from '../../back-office/admin/ai-trip-planner/ai-itinerary/ai-itinerary.component';


export const UserLayoutRoutes: Routes = [

    { path: 'home', component: HomeComponent },
    { path: 'profile', component: ProfileComponent },
    { path: 'personal-information', component: personalInformation },
    { path: 'family-members', component: FamilyMembersComponent },
    // { path: 'packages', component: PackageComponent },
    { path: 'packages-details', component: PackageDetailsComponent },
    { path: 'booking-review', component: BookingReviewComponent },
    { path: 'contact-us', component: ContactUsComponent },
    { path: 'faqs', component: FaqsComponent },
    { path: 'bookings', component: BookingsComponent },
    { path: 'saved-itinerary', component: SavedItineraryComponent },
    { path: 'medications', component: MedicationsComponent },
    { path: 'government-travel-advice', component: GovernmentTravelAdvice },
    { path: 'privacy-statement', component: PrivacyStatement },
    { path: 'cancellation-policy/:packageId', component: CancellationPolicyComponent },
    { path: 'rules-and-restrictions', component: RulesAndRestrictionComponent },
    { path: 'terms-of-use', component: TermsOfUseComponent },
    { path: 'kumbh', component: KumbhComponent },
    { path: 'packages', component: DivineDestinationComponent },
    { path: 'trendingFestival', component: TrendingFestivalComponent },
    { path: 'who-we-are', component: WhoAreWeComponent },
    { path: 'about-us', component: AboutUsComponent },
    { path: 'why-choose-MyYatra360', component: WhyChooseUsComponent },
    { path: 'happy-travelers', component: HappyTravelerComponent },
    { path: 'ai-trip', component: AiTripComponent },
    { path: 'ai-trip-first', component: AiTripFirstComponent },
    { path: 'ai-trip-second', component: AiTripSecondComponent },
    { path: 'ai-itinerary', component: AiItineraryComponent },
];
